module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_m_jp.313fb8598d536145983562ef16569d75.png";